import { useTranslation } from 'react-i18next';
import { ReactComponent as ArrowLeftIcon } from 'assets/icons/arrow-left.svg';
import Button from 'components/Button/Button';
import ContentLoader from 'components/ContentLoader/ContentLoader';
import EmptyTaskManagement from 'components/EmptyTaskManagement/EmptyTaskManagement';
import Panel from 'components/Panel/Panel';
import { TASK_RESPONDENT_SURVEYS_CONFIG_CELLS } from 'constants/dataSets';
import { BUTTON_VARIANT } from 'constants/interfaces';

import DetailsModal from './components/DetailsModal/DetailsModal';
import ItemsTable from './components/ItemsTable/ItemsTable';

import type IMARespondentSurveys from './interfaces/IMARespondentSurveys';

import styles from './scss/MARespondentSurveys.module.scss';

function MARespondentSurveysView({
  loading, handleBack, isEmptyList,
  items, onLoadMore, hasMore, handleGetDetails,
  openModal, handleCancelModal, details,
}: IMARespondentSurveys) {
  const { t } = useTranslation();
  return (
    <Panel className={styles.root}>
      <div className={styles.rootContainer}>
        <div className={styles.wrapper}>
          <Button
            title={t('materialityAssessment.back')}
            onClick={handleBack}
            variant={BUTTON_VARIANT.ghost}
            startIcon={<ArrowLeftIcon />}
          />
          <div className={styles.contentWrapper}>
            {loading ? (<ContentLoader title={t('materialityAssessment.loadingRespondentSurveys')} />) : null}
            {isEmptyList && !loading ? (
              <EmptyTaskManagement
                title={t('materialityAssessment.emptyTopicRefinement')}
                checkIcon
              />
            ) : null}
            {!isEmptyList && !loading ? (
              <div className={styles.tableWrapper}>
                <div className={styles.titleWrapper}>
                  <span className={styles.title}>{t('materialityAssessment.respondentSurveys')}</span>
                </div>
                <ItemsTable
                  items={items}
                  headCells={TASK_RESPONDENT_SURVEYS_CONFIG_CELLS}
                  onLoadMore={onLoadMore}
                  hasMore={hasMore}
                  isLoadingMore={loading}
                  handleGetDetails={handleGetDetails}
                  isInfoTable
                />
              </div>
            ) : null}
          </div>
        </div>
        <DetailsModal
          open={openModal}
          handleCancelModal={handleCancelModal}
          details={details}
          title={t('materialityAssessment.respondentSurveyResponses')}
        />
      </div>
    </Panel>
  );
}

export default MARespondentSurveysView;
